module.exports = __webpack_public_path__ + "static/img/ys3.eaa5aba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ys3.jpg
// module id = ySl8
// module chunks = 1